module.exports = __webpack_public_path__ + "static/media/79.82f8e512.jpg";